import * as PIXI from "pixi.js";
import Layers from "../../layers/Layers";
import { BaseSButtonStyle } from "../../types/Interface";
import addInteractivity from "../../utils/addInteractivity";
import { CustomCursorType } from "./CustomCursor/CustomCursor";


export default class BaseButton extends PIXI.Container {
  Layers = Layers.getInstance();
  bg!: PIXI.Graphics;
  title!: PIXI.Text;
  style: BaseSButtonStyle;
  titleText: string
  handleFunc: () => void;
  constructor(title: string, style: BaseSButtonStyle, handleFunc: () => void) {
    super();
    this.style = style;
    this.titleText = title;
    this.handleFunc = handleFunc;
    this.addBg(style);
    this.addTitle(title, style.titleColor);
    this.handleEvents();
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.UI.addChild(this);

  private handleEvents() {
    const handleDownFunc = () => {
      this.drawBg(this.style, this.style.pressedColor);
      this.handleFunc();
    }
    const handleUpFunc = () => this.drawBg(this.style, this.style.hoverColor);

    addInteractivity(
      this,
      { handleDownFunc, handleUpFunc },
      CustomCursorType.pointer,
      undefined,
      true
    );
    this.on("pointerleave", () => this.drawBg(this.style, this.style.defaultColor));
  }
  private addTitle(title: string, color: number) {
    this.title = this.addChild(new PIXI.Text({ text: title }));
    this.title.style = {
      fill: color,
      fontSize: this.style.titleFontSize,
      wordWrap: true,
      wordWrapWidth: this.style.wordWrapWidth,
      align: "center",
    }
    this.title.anchor.set(.5);
  }
  private addBg(style: BaseSButtonStyle) {
    this.bg = this.addChild(new PIXI.Graphics());
    this.drawBg(style, style.defaultColor);
  }
  private drawBg(style: BaseSButtonStyle, color: number) {
    this.bg
      .clear()
      .roundRect(-style.width / 2, -style.height / 2, style.width, style.height, style.borderRadius)
      .stroke({ width: 5, color: style.borderColor })
      .fill(color);
  }
  handleTitle(title: string, color: number) {
    this.titleText = title;
    this.title.text = title;
    this.title.style.fill = color;
  }
}